import BoxLogin from '@derolfgroep/ui-components/src/components/BoxLogin/BoxLogin'
import { redirectToAuthService } from '../../auth/utils'
import { Box, Button, Typography } from '@mui/material'
import { ExitToAppRounded as IconExitToAppRounded } from '@mui/icons-material'
import BreadcrumbsSingle from '@derolfgroep/ui-components/src/components/Breadcrumbs/BreadcrumbsSingle'

const SessionExpired = () => (
  <BoxLogin>
    <BreadcrumbsSingle title="Je sessie is verlopen" />
    <Box mt={1}>
      <Typography>
        Wanneer je een lange tijd niets hebt gedaan, dan wordt je sessie beëindigd door ZuluConnect Portal. Dit doen we
        voor je veiligheid en de bescherming van je gegevens.
      </Typography>
    </Box>
    <Box mt={2}>
      <Button
        onClick={redirectToAuthService}
        size="large"
        variant="contained"
        color="primary"
        fullWidth
        startIcon={<IconExitToAppRounded />}
      >
        Klik hier om opnieuw in te loggen
      </Button>
    </Box>
  </BoxLogin>
)

export default SessionExpired
